export const cleanJsonResponse = (raw: string) => {
    return raw
        .replace(/^```json\s*/i, "") // remove ```json at start (case-insensitive)
        .replace(/^```\s*/i, "") // fallback: just ``` at start
        .replace(/\s*```$/, ""); // remove ending ```
};

export const removeAtIndex = (array: any[], index: number): any[] => {
    return array.slice(0, index).concat(array.slice(index + 1));
};

export const capitalize = (s: string) => (s.length > 0 ? s[0].toUpperCase() + s.slice(1) : s);
